import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PillarGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: '16px',
  gridTemplateColumns: 'repeat(2, 1fr)',
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr',
  },
}));
